// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"453":"03f0ba2a","821":"d84cdfe7"}[chunkId] + ".chunk.js");